// Escapes the five HTML-significant characters so a user- or tenant-controlled
// string can be safely interpolated into an HTML string. Used by the receipt
// printer, which builds markup by concatenation and writes it into a same-origin
// print window — without escaping, a member/item name containing markup executes
// script there and can read tokens from localStorage (DOM XSS, FORT-271).
export const escapeHtml = (value: string | null | undefined): string =>
  (value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
